import {
  decodeBase64,
  encodeBase64,
} from "../../../general/functions/base64Function";

export const GetParamBase64 = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const pdulisession = urlParams.get("pdulisession");
  return pdulisession;
};

export const UserDataPduliEncode = (
  idUserPduli,
  session,
  kodeVC,
  typeUser,
  token
) => {
  let codeR = Math.floor(Math.random() * 90000) + 10000;
  const data = [codeR, idUserPduli, session, kodeVC, typeUser, token];
  let base64 = encodeBase64(data.join(";"));
  localStorage.setItem("bkdp_pduli_key", codeR);
  return {
    base64: base64,
  };
};

export const UserDatPduliaDecode = () => {
  try {
    let tmp = localStorage.getItem("bkdp_pduli_key");
    let encData = decodeBase64(GetParamBase64()).split(";");
    if (tmp == encData[0]) {
      return {
        idUserPduli: encData[1],
        session: encData[2],
        kodeVC: encData[3],
        typeUser: encData[4],
        token: encData[5],
      };
    } else {
      return {
        idUserPduli: null,
        session: null,
        kodeVC: null,
        typeUser: null,
        token: null,
      };
    }
  } catch (error) {
    return {
      idUserPduli: null,
      session: null,
      kodeVC: null,
      typeUser: null,
      token: null,
    };
  }
};
